import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import SingleChoice from "./ComponentV6/SingleChoice";
import MultipleChoice from "./ComponentV6/MultipleChoice";
import TextBox from "./ComponentV6/TextBox";
import MultiLineText from "./ComponentV6/MultiLineText";
import RatingScale from "./ComponentV6/RatingScale";
import NPS from "./ComponentV6/NPS";
import NPSV2 from "./ComponentV6/NPSV2";
import Email from "./ComponentV6/Email";
import Number from "./ComponentV6/Number";
import Dropdown from "./ComponentV6/Dropdown";
import YesNo from "./ComponentV6/YesNo";
import Date from "./ComponentV6/Date";

import QuestionHeader from "../Component/QuestionHeader";

import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";
import { IoIosArrowDown } from "react-icons/io";


class SurveyRTL extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }






  render() {

    let {
      clicked,
      handleRadio,
      viewReport,
      onLogout,
      handleLanguage,
      handleNameInput,
      onUpdateDetails,
      goToUpdateDetailsPage,
      goToQuestionPage,
      ansNPSInput,
      nextQues,
      onMandatoryAttempt,
      saveAnswers,

      getSecondsToTimeReverse,
      isSchool,
      surveyLanguageRTL,
      showNameEditScreen,
      nameFormData,
      errNameForm,
      surveyScreenData,
      getAssessmenrEmployeeDetailsData,
      surveyLanguageName,
      LanguageList,
      surveyStatus,

      showWelcomeScreen,
      questionsList,
      themeType,
      getTheme,
      SurveyAttributes,
      surveyLanguageCode,
      functionNameVariable,
      welcomeTextDislay,
      instructionPage,
      LabelObj,
      instructionTextDislay,
      afterSubmitData,
      showQuestionScreen,
      submitSucces,
      getSecondsToTime,
      CurrQuesIndex,
      answersList,
      isMobile,

      unattemptList,
      showRedFlag,
      ShowSubmitButton,
      submitMandatory,

      showThankyouScreen,
      showViewReportThankYouButton,
      alreadySubmitted,
      downloadStatusNo,
      handleGenderChange,
      handleAgeGroupChange,

      bgType, bgColor, timeCounter, getGroupIndex, hexToRgbA,
      bgImage,



    } = this.props;

    return (
      <>
        <div
          className="w-full h-screen overflow-hidden bg-center bg-cover"
          style={{
            backgroundImage: getTheme(
              "backgroundImage",
              'url("/img/survey-bg.jpg")'
            ),
          }}
        >
          <LogoAssessmentHeader
            logout={onLogout}
            surveyScreenData={surveyScreenData}
            template={"v4"}
            details={getAssessmenrEmployeeDetailsData}
            handleReport={viewReport}
            surveyLanguageName={surveyLanguageName}
            handleLanguage={handleLanguage}
            LanguageList={LanguageList}
          />

          {/* Welcome Section */}
          {surveyStatus !== 2 && surveyStatus !== 3 ? (
            <>
              {showWelcomeScreen &&
                questionsList &&
                questionsList.length > 0 ? (
                <>

                  {showNameEditScreen ?
                    <>
                      <div>
                        {/* showNameEditScreen update your details second screen */}
                        <section dir="rtl" className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-10 py-4 flex items-start h-[calc(100vh-5rem)]">
                          {/* right side image section */}
                          <div className="justify-center hidden w-5/12 h-full md:flex ">
                            <div
                              className="bg-[#bbdefb] rounded-2xl flex justify-center items-center  w-full "
                              style={{
                                backgroundImage: getTheme(
                                  "welcomeImage",
                                  "/img/talent_assessment_intro.svg"
                                ),
                                backgroundSize: "cover",
                              }}
                            >
                              {themeType === 1 ? (
                                <img
                                  src={getTheme(
                                    "welcomeImage",
                                    "/img/talent_assessment_intro.svg"
                                  )}
                                  className="w-11/12 mx-auto 2xl:w-10/12"
                                />
                              ) : null}
                            </div>
                          </div>

                          {/*  Please update your details form*/}
                          <div className="flex flex-col justify-between w-full h-full space-y-8 md:w-7/12 2xl:space-y-10 xl:space-y-8">
                            <div className="text-base font-normal text-white md:space-y-4 " style={{ color: getTheme("text", "#FFFFFF") }}>


                              <div className="space-y-4 md:px-10" style={{ color: getTheme("text", "#FFFFFF") }}>

                                <div className="w-full py-2 mx-auto 2xl:w-4/6 lg:w-5/6">
                                  <h1 className="py-4 pb-8 text-2xl font-medium xl:text-4xl text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                    {SurveyAttributes("Please_update_your_details") ? SurveyAttributes("Please_update_your_details") : "Please update your details"}
                                  </h1>
                                  <div className="text-base font-bold ">{SurveyAttributes("Name") ? SurveyAttributes("Name") : "Name"}<span className="text-red-500">*</span></div>
                                  <input name="name" value={nameFormData.name} onChange={handleNameInput} placeholder={SurveyAttributes("Name") ? SurveyAttributes("Name") : "Name"} className="w-full p-3 mt-2 border focus:ring-1 ring-[#2196f3] focus:outline-none  rounded-md  " />
                                  <div className="text-lg font-normal text-red-500">{errNameForm && errNameForm.name ? errNameForm.name : ""}</div>
                                  <br />

                                  <div className="text-base font-bold ">{SurveyAttributes("Email") ? SurveyAttributes("Email") : "Email"}<span className="text-red-500">*</span></div>
                                  <input name="email" value={nameFormData.email} onChange={handleNameInput} placeholder={SurveyAttributes("Email") ? SurveyAttributes("Email") : "Email"} className="w-full p-3 mt-2 border  rounded-md   focus:ring-1 ring-[#2196f3] focus:outline-none" />

                                  <div className="mt-2 text-lg font-normal text-red-500">{errNameForm && errNameForm.email ? errNameForm.email : ""}</div>
                                  <br />

                                  {
                                    isSchool ?
                                      <div className="" >
                                        <div className="space-y-2 ">
                                          <label className="mb-2 text-base font-bold">What is your gender?<span className="text-red-500">*</span></label>
                                          <div className="relative w-full ">
                                            <select className="w-full p-3 text-[#212121] bg-white border   rounded-md  outline-none appearance-none" onChange={handleGenderChange}>
                                              <option disabled selected>Select</option>
                                              <option value="Male">Male</option>
                                              <option value="Female">Female</option>
                                              <option value="Others">Others</option>
                                              <option value="Prefer not to say">Prefer not to say</option>
                                            </select>
                                            <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-500 pointer-events-none">
                                              <IoIosArrowDown className="w-4 h-4 fill-current" />
                                            </div>
                                          </div>

                                        </div>
                                        <div className="mt-2 text-lg font-normal text-red-500">{errNameForm && errNameForm.gender ? errNameForm.gender : ""}</div>
                                        <br />
                                        <div className="space-y-2 ">
                                          <label className="mb-2 text-base font-bold">What is your age group?<span className="text-red-500">*</span></label>
                                          <div className="relative w-full ">
                                            <select className="w-full p-3 text-[#212121] bg-white border   rounded-md  outline-none appearance-none" onChange={handleAgeGroupChange}>
                                              <option disabled selected>Select</option>
                                              <option value="Below 15 Years (For TeenTalent)">Below 15 Years (For TeenTalent)</option>
                                              <option value="15 Years to 18 Years (For TeenTalent)">15 Years to 18 Years (For TeenTalent)</option>
                                              <option value="18 Years to 21 Years (For TeenTalent)">18 Years to 21 Years (For TeenTalent)</option>
                                              <option value="21 Years to 25 Years">21 Years to 25 Years</option>
                                              <option value="26 years to 35 Years">26 years to 35 Years</option>
                                              <option value="36 Years to 45 Years">36 Years to 45 Years</option>
                                              <option value="46 years to 60 Years">46 years to 60 Years</option>
                                              <option value="Above 60 years">Above 60 years</option>
                                            </select>
                                            <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-500 pointer-events-none">
                                              <IoIosArrowDown className="w-4 h-4 fill-current" />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="mt-2 text-lg font-normal text-red-500">{errNameForm && errNameForm.ageGroup ? errNameForm.ageGroup : ""}</div>

                                      </div>
                                      : null
                                  }

                                  <button onClick={() => onUpdateDetails()} className="mt-8  w-full uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"><span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                                    {SurveyAttributes("Continue")
                                      ? SurveyAttributes("Continue")
                                      : "Continue"}
                                  </button>

                                </div>

                              </div>
                            </div>

                            <div className="flex flex-col justify-start w-full space-y-4 md:space-y-8 md:pl-10">
                              <div className="flex justify-center mt-4 mb-2 md:justify-end">
                                <p
                                  className="text-sm text-white/80"
                                  style={{ color: getTheme("text", "#FFFFFF") }}
                                >
                                  © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}{" "}
                                  <b
                                    className="font-medium text-white/100"
                                    style={{
                                      color: getTheme("text", "#FFFFFF"),
                                    }}
                                  >
                                    {SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}
                                  </b>
                                </p>
                              </div>
                            </div>
                          </div>

                          {/*  */}
                        </section>
                      </div>


                    </>
                    :
                    <div>
                      {/* Welcome to the world First Scrren */}
                      <section dir="rtl" className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-10 py-4 lg:space-x-10  flex   items-start h-[calc(100vh-5rem)]">
                        {/* right image section*/}
                        <div className="justify-center hidden w-5/12 h-full md:flex mx-12">
                          <div dir="rtl"
                            className="bg-[#bbdefb] rounded-2xl flex justify-center items-center  w-full "
                            style={{
                              backgroundImage: getTheme(
                                "welcomeImage",
                                "/img/talent_assessment_intro.svg"
                              ),
                              backgroundSize: "cover",
                            }}
                          >
                            {themeType === 1 ? (
                              <img
                                src={getTheme(
                                  "welcomeImage",
                                  "/img/talent_assessment_intro.svg"
                                )}
                                className="w-11/12 mx-auto 2xl:w-10/12"
                              />
                            ) : null}
                          </div>
                        </div>

                        {/* welcome to the world of Infinite possibilities */}
                        <div className="w-full space-y-8 md:w-7/12 2xl:space-y-10 xl:space-y-8 ">
                          <div className="h-full text-base font-normal text-white md:space-y-4 " style={{ color: getTheme("text", "#FFFFFF") }}>

                            <h1 className="pb-4 text-right text-xl font-semibold left 2xl:text-4xl xl:text-3xl text-white/100"
                              style={{ color: getTheme("text", "#FFFFFF") }}>
                              {SurveyAttributes("Welcome_to_the_world_of_Infinite_possibilities") ? SurveyAttributes("Welcome_to_the_world_of_Infinite_possibilities") : "Welcome to the world of Infinite possibilities"}
                            </h1>


                            <div className="lg:h-[calc(100vh-23rem)] md:h-[calc(100vh-26rem)] h-[calc(100vh-24rem)] overflow-y-auto  space-y-4 md:p-8 p-4 bg-white rounded-md shadow-md " style={{ color: getTheme("text", "#FFFFFF") }}>
                              {surveyLanguageCode !== "" &&
                                surveyLanguageCode !== "en" ? (
                                <div dangerouslySetInnerHTML={{
                                  __html:
                                    functionNameVariable((surveyLanguageCode !== '') ?
                                      (surveyScreenData && surveyScreenData.transl && surveyScreenData.transl[surveyLanguageCode] && surveyScreenData.transl[surveyLanguageCode].welcomeText) ? surveyScreenData.transl[surveyLanguageCode].welcomeText : welcomeTextDislay
                                      : welcomeTextDislay)
                                }} />
                              ) : (
                                <div className="space-y-4 " >
                                  <p className="text-lg font-semibold">
                                    Hello,
                                  </p>

                                  <p className="text-md">
                                    We all are born with unique talents. Lot
                                    of us realise it at some point of time in
                                    our life. Luckier are those who get to
                                    know about it at the beginning of their
                                    life and use it to live a fulfilling and
                                    thriving life. But most of us are either
                                    unaware or realise our inherent talent
                                    quite late in our life, thus making our
                                    work & life boring.
                                  </p>

                                  <p className="text-lg font-semibold">
                                    Now, no more.
                                  </p>

                                  <p className="text-md">
                                    <b className="font-semibold">
                                      {" "}
                                      TalentPlusStrengths  assessment,{" "}
                                    </b>{" "}
                                    will allow you to know your inherent
                                    talents with a click of a button. Respond
                                    to our scientifically designed
                                    questionnaire and press the submit button.
                                    You will be able to download your talent
                                    themes immediately.
                                  </p>

                                  <p className="text-lg font-semibold !-mb-4">
                                    Instructions:
                                  </p>

                                  <ul className="list-decimal list-inside text-md ">
                                    <li>
                                      {" "}
                                      The test will take around{" "}
                                      <b className="font-semibold ">
                                        40 minutes
                                      </b>{" "}
                                      to finish.
                                    </li>
                                    <li>
                                      {" "}
                                      You get{" "}
                                      <b className="font-semibold ">
                                        20 seconds
                                      </b>{" "}
                                      to respond to each question.
                                    </li>
                                    <li>
                                      {" "}
                                      You should respond with your{" "}
                                      <b className="font-semibold ">
                                        first thought.
                                      </b>
                                    </li>
                                    <li>
                                      {" "}
                                      It’s a{" "}
                                      <b className="font-semibold ">
                                        10-point rating scale
                                      </b>
                                      , where{" "}
                                      <b className="font-semibold ">
                                        1 is Not like you
                                      </b>{" "}
                                      and{" "}
                                      <b className="font-semibold ">
                                        10 is Exactly like you.
                                      </b>
                                    </li>
                                    <li>
                                      {" "}
                                      There is no{" "}
                                      <b className="font-semibold ">
                                        right
                                      </b>{" "}
                                      or{" "}
                                      <b className="font-semibold ">wrong</b>{" "}
                                      answer. It’s just what you feel about a
                                      statement.{" "}
                                    </li>
                                  </ul>

                                  <p className=" text-md">
                                    Once done, press the submit button and
                                    click on your profile to see your result.
                                    Although the report is quite detailed and
                                    should give you a very deep insight on you
                                    and your talents still a coaching call
                                    with TalentPlusStrengths  Consultant is recommended.
                                    You can fix up the same by writing to us
                                    at
                                    <b> contact@happyplus.in</b>
                                  </p>

                                  <p className="block text-md">
                                    All the best.
                                  </p>
                                  <p className="text-lg font-medium">
                                    HappyPlus Assessment Team.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex flex-col justify-start w-full space-y-4 md:space-y-8 ">
                            <button
                              onClick={() => goToUpdateDetailsPage()}
                              className="md:w-80 w-full  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 lg:py-4  py-3 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"
                            >
                              <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-[30rem] group-hover:h-[30rem] opacity-10"></span>
                              {SurveyAttributes("Start_Assessment")
                                ? SurveyAttributes(
                                  "Start_Assessment"
                                )
                                : "START ASSESSMENT"}
                            </button>

                            <div className="flex justify-center mb-2 md:justify-end">
                              <p
                                className="text-sm text-white/80"
                                style={{ color: getTheme("text", "#FFFFFF") }}
                              >
                                © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}{" "}
                                <b
                                  className="font-medium text-white/100"
                                  style={{
                                    color: getTheme("text", "#FFFFFF"),
                                  }}
                                >
                                  {SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}
                                </b>
                              </p>
                            </div>
                          </div>
                        </div>

                        {/*  */}
                      </section>
                    </div>
                  }
                </>
              ) : null}

              {/* Instruction Section */}

              {instructionPage ? (
                <>
                  <div dir="rtl" >
                    <section
                      className="px-2 py-4 mx-auto lg:w-5/6 md:py-6 lg:px-0 md:px-6 "
                      style={{ height: "75%" }}
                    >
                      {/* logo */}
                      <div className="flex justify-center -mt-4"></div>

                      <p
                        style={{
                          color:
                            surveyScreenData && surveyScreenData.textcolor
                              ? surveyScreenData.textcolor
                              : "black",
                        }}
                        className="py-2 text-2xl font-bold text-center"
                      >
                        {LabelObj &&
                          LabelObj[surveyLanguageCode] &&
                          LabelObj[surveyLanguageCode].InstructionLabelText
                          ? LabelObj[surveyLanguageCode]
                            .InstructionLabelText
                          : SurveyAttributes("instructionLabel")
                            ? SurveyAttributes("instructionLabel")
                            : "Instructions"}
                      </p>

                      {/* pragraph */}
                      <div className="pb-24">
                        <div
                          id="chatbot"
                          className="mx-4 mt-2 overflow-y-auto cursor-default lg:px-14 lg:pl-32 lg:pr-4"
                          style={{
                            height: "400px",
                            color:
                              surveyScreenData && surveyScreenData.textcolor
                                ? surveyScreenData.textcolor
                                : "black",
                          }}
                          dangerouslySetInnerHTML={{
                            __html:
                              surveyLanguageCode !== ""
                                ? surveyScreenData &&
                                  surveyScreenData.transl &&
                                  surveyScreenData.transl[
                                  surveyLanguageCode
                                  ] &&
                                  surveyScreenData.transl[
                                    surveyLanguageCode
                                  ].instructionText
                                  ? surveyScreenData.transl[
                                    surveyLanguageCode
                                  ].instructionText
                                  : instructionTextDislay
                                : instructionTextDislay,
                          }}
                        />
                      </div>
                      <div className="flex justify-center ">
                        <div>
                          <button
                            onClick={() => goToQuestionPage()}
                            className="w-80  uppercase text-xl font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden"

                          >
                            {SurveyAttributes("Continue")
                              ? SurveyAttributes("Continue")
                              : "Continue"}
                          </button>
                          <p
                            style={{
                              backgroundColor:
                                bgType === 1 || afterSubmitData.bgType === 1
                                  ? bgColor
                                    ? bgColor
                                    : afterSubmitData.bgColor
                                      ? afterSubmitData.bgColor
                                      : "#757575"
                                  : "#f1f1f1",
                            }}
                            className="py-4 pl-6 text-sm"
                          >
                            {" "}
                            © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}{" "}
                            <b className="font-semibold">{SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}</b>
                          </p>
                        </div>
                      </div>
                      {/*  */}
                    </section>
                  </div>
                </>
              ) : null}

              {/* Question Section */}

              {showQuestionScreen && !submitSucces ? (
                <div>
                  <div dir="rtl" className="md:h-16 h-14 w-full bg-[#2196f3] flex items-center ">
                    <div className="flex items-center justify-between w-full px-4 mx-auto xl:w-11/12 xl:px-0 ">

                      <div dir="rtl" className="flex items-center text-white md:space-x-2 ">
                        <div className="flex items-center space-x-2 ">
                          <span className="material-symbols-outlined md:text-[2rem] text-[1rem]">
                            schedule
                          </span>
                          <p className="text-sm md:text-xl ">
                            {SurveyAttributes("Remaining")
                              ? SurveyAttributes("Remaining")
                              : "Remaining"}
                          </p>
                        </div>
                        <h1 className="p-2 text-sm font-medium md:text-2xl">
                          {getSecondsToTimeReverse(timeCounter)}
                        </h1>
                      </div>
                      <div dir="rtl" className="flex items-center space-x-2 text-white md:space-x-2 ">
                        <span className="material-symbols-outlined md:text-[2rem] text-[1rem]">
                          check_circle
                        </span>
                        <h1 className="text-sm font-medium md:text-2xl">
                          {(CurrQuesIndex).toString() + " "}
                          <b className="font-medium text-white/60 ">
                            {" "}
                            /{" "}
                            {questionsList && questionsList.length > 0
                              ? questionsList.length
                              : 0}
                          </b>
                        </h1>
                      </div>

                    </div>
                  </div>
                  <div dir="rtl" className={"md:h-14 h-10 w-full flex items-center  " + getTheme("grayheader", " bg-black/20 ")}>
                    <div className="flex items-center justify-center w-full px-6 mx-auto 2xl:w-8/12 xl:w-10/12 xl:px-0 ">
                      <div className="flex items-center space-x-4 text-white ">
                        <span
                          className="material-symbols-outlined md:text-[2rem] text-[1.5rem]"
                          style={{ color: getTheme("text", "#FFFFFF") }}
                        >
                          tips_and_updates
                        </span>
                        <p
                          className="text-sm md:text-xl "
                          style={{ color: getTheme("text", "#FFFFFF") }}
                        >
                          {SurveyAttributes("Kindly_answer_the_given_question")
                            ? SurveyAttributes("Kindly_answer_the_given_question")
                            : "Kindly answer the given question"}

                        </p>
                      </div>


                    </div>
                  </div>

                  <section className="2xl:mt-24 xl:mt-24 lg:mt-12 md:mt-12 mt-4  2xl:w-3/6 xl:w-4/6 lg:w-5/6 w-full md:py-2 py-4 mx-auto lg:px-0 md:px-6 px-2 overflow-y-hidden overflow-x-hidden flex h-[calc(100vh-14rem)] ">
                    <div className="w-full">
                      {questionsList && questionsList.length > 0
                        ? questionsList.map((question, questionindex) =>
                          questionindex + 1 === CurrQuesIndex ? (
                            // CurrQuesIndex

                            <>
                              <div>
                                {question.templateId !== 14 ? (
                                  question.templateId === 10 ? (

                                    <p
                                      style={{
                                        color: getTheme(
                                          "text",
                                          "#FFFFFF"
                                        ),
                                      }}
                                      className="px-4 py-4 mb-4 text-2xl italic font-semibold text-left text-white cursor-default quz md:text-2xl md:px-6 md:py-6 md:mt-4"
                                    >
                                      <span className="font-bold">
                                        {functionNameVariable(
                                          surveyLanguageCode !== ""
                                            ? question &&
                                              question.transl &&
                                              question.transl[
                                              surveyLanguageCode
                                              ] &&
                                              question.transl[
                                                surveyLanguageCode
                                              ].name
                                              ? question.transl[
                                                surveyLanguageCode
                                              ].name
                                              : question.name
                                            : question.name
                                        )}
                                      </span>

                                      {question.isMandatory ? (
                                        <div
                                          style={{
                                            background:
                                              surveyScreenData &&
                                                surveyScreenData.OptionColor1
                                                ? surveyScreenData.OptionColor1
                                                : "white",
                                            color: getTheme(
                                              "text",
                                              "#FFFFFF"
                                            ),
                                          }}
                                          className="font-semibold text-gray-500 bg-gray-300 shadow-lg subtitle"
                                        >
                                          {SurveyAttributes(
                                            "mandatoryText"
                                          )
                                            ? SurveyAttributes(
                                              "mandatoryText"
                                            )
                                            : "This question is mandatory"}
                                        </div>
                                      ) : null}
                                    </p>

                                  ) : (
                                    <>
                                      {question.parentId ? (
                                        <>
                                          {question &&
                                            question["QuesMain"] ? (

                                            <QuestionHeader
                                              surveyLanguageCode={
                                                surveyLanguageCode
                                              }
                                              question={
                                                question["QuesMain"]
                                              }
                                            />

                                          ) : null}

                                          <div
                                            style={{
                                              color: getTheme(
                                                "text",
                                                "#FFFFFF"
                                              ),
                                            }}
                                            className="px-4 py-2 mb-2 text-lg font-semibold text-left text-white cursor-default quz md:text-2xl md:px-6 md:py-4 md:mt-2"
                                          >
                                            {getGroupIndex(
                                              question["QuesMain"].id
                                            )}
                                            {functionNameVariable(
                                              surveyLanguageCode !==
                                                ""
                                                ? question &&
                                                  question[
                                                  "QuesMain"
                                                  ] &&
                                                  question["QuesMain"]
                                                    .transl &&
                                                  question["QuesMain"]
                                                    .transl[
                                                  surveyLanguageCode
                                                  ] &&
                                                  question["QuesMain"]
                                                    .transl[
                                                    surveyLanguageCode
                                                  ].name
                                                  ? question[
                                                    "QuesMain"
                                                  ].transl[
                                                    surveyLanguageCode
                                                  ].name
                                                  : question && [
                                                    "QuesMain",
                                                  ] &&
                                                    question[
                                                      "QuesMain"
                                                    ].name
                                                    ? question[
                                                      "QuesMain"
                                                    ].name
                                                    : ""
                                                : question && [
                                                  "QuesMain",
                                                ] &&
                                                  question["QuesMain"]
                                                    .name
                                                  ? question["QuesMain"]
                                                    .name
                                                  : ""
                                            )}
                                          </div>

                                          <div
                                            style={{
                                              color: getTheme(
                                                "text",
                                                "#FFFFFF"
                                              ),
                                            }}
                                            className={
                                              question.templateId ===
                                                3 ||
                                                question.templateId ===
                                                4 ||
                                                question.templateId ===
                                                6 ||
                                                question.templateId ===
                                                16
                                                ? "text-left mb-0 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-normal  md:mt-2"
                                                : " mb-2 cursor-default quz md:text-2xl md:px-6 px-4 text-lg text-white font-normal md:mt-2  text-left"
                                            }
                                          >
                                            {question.isMandatory ? (
                                              <div className="text-sm text-red-500 ">
                                                {SurveyAttributes(
                                                  "mandatoryText"
                                                )
                                                  ? SurveyAttributes(
                                                    "mandatoryText"
                                                  )
                                                  : "This question is mandatory*"}
                                              </div>
                                            ) : null}

                                            {/* {(questionindex+1).toString()+'. '} */}
                                            <span className="font-bold">
                                              {" "}
                                              {functionNameVariable(
                                                surveyLanguageCode !==
                                                  ""
                                                  ? question &&
                                                    question.transl &&
                                                    question.transl[
                                                    surveyLanguageCode
                                                    ] &&
                                                    question.transl[
                                                      surveyLanguageCode
                                                    ].name
                                                    ? question.transl[
                                                      surveyLanguageCode
                                                    ].name
                                                    : question.name
                                                  : question.name
                                              )}{" "}
                                            </span>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="quz">
                                            <QuestionHeader
                                              surveyLanguageCode={
                                                surveyLanguageCode
                                              }
                                              questionName={functionNameVariable(
                                                surveyLanguageCode !==
                                                  ""
                                                  ? question &&
                                                    question.transl &&
                                                    question.transl[
                                                    surveyLanguageCode
                                                    ] &&
                                                    question.transl[
                                                      surveyLanguageCode
                                                    ].name
                                                    ? question.transl[
                                                      surveyLanguageCode
                                                    ].name
                                                    : question.name
                                                  : question.name
                                              )}
                                              QuesNo={
                                                (
                                                  questionindex + 1
                                                ).toString() + ". "
                                              }
                                            />
                                          </div>

                                          <div
                                            style={{
                                              color: getTheme(
                                                "text",
                                                "#FFFFFF"
                                              ),
                                            }}
                                            className="px-4 mb-2 text-lg font-normal text-left text-white cursor-default quz md:text-2xl md:px-6 md:mt-4"
                                          >
                                            {question.isMandatory ? (
                                              <div className="text-sm text-red-500 ">
                                                {SurveyAttributes(
                                                  "mandatoryText"
                                                )
                                                  ? SurveyAttributes(
                                                    "mandatoryText"
                                                  )
                                                  : "This question is mandatory*"}
                                              </div>
                                            ) : null}

                                            {surveyLanguageRTL ?
                                              <div className="flex flex-row-reverse gap-2">
                                                <p> {" ." + (questionindex + 1).toString()}</p>
                                                <p>{functionNameVariable(
                                                  surveyLanguageCode !==
                                                    ""
                                                    ? question &&
                                                      question.transl &&
                                                      question.transl[
                                                      surveyLanguageCode
                                                      ] &&
                                                      question.transl[
                                                        surveyLanguageCode
                                                      ].name
                                                      ? question.transl[
                                                        surveyLanguageCode
                                                      ].name
                                                      : question.name
                                                    : question.name
                                                )}</p>

                                              </div>
                                              :
                                              <div className="flex flex-row gap-2">
                                                <p> {(questionindex + 1).toString() + ". "}</p>
                                                <p>{functionNameVariable(
                                                  surveyLanguageCode !==
                                                    ""
                                                    ? question &&
                                                      question.transl &&
                                                      question.transl[
                                                      surveyLanguageCode
                                                      ] &&
                                                      question.transl[
                                                        surveyLanguageCode
                                                      ].name
                                                      ? question.transl[
                                                        surveyLanguageCode
                                                      ].name
                                                      : question.name
                                                    : question.name
                                                )}</p>
                                              </div>
                                            }

                                          </div>
                                        </>
                                      )}
                                    </>
                                  )
                                ) : null}



                                {/* Single Choice */}
                                {question.templateId === 1 ? (
                                  <>
                                    <SingleChoice
                                      question={question}
                                      clicked={clicked}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      handleRadio={handleRadio}
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      isMobile={isMobile}
                                    />
                                  </>
                                ) : null}

                                {/* Multiple Choice */}
                                {question.templateId === 2 ? (
                                  <>
                                    <MultipleChoice
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      handleCheckInput={
                                        this.handleCheckInput
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* Multitext Box */}
                                {question.templateId === 3 ? (
                                  <>
                                    <TextBox
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                      ansTextBoxChange1={
                                        this.ansTextBoxChange1
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                    />
                                  </>
                                ) : null}

                                {/* Multitext Box */}
                                {question.templateId === 4 ? (
                                  <>
                                    <MultiLineText
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                      ansTextBoxChange1={
                                        this.ansTextBoxChange1
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                    />
                                  </>
                                ) : null}

                                {/* Rating Scale */}
                                {question.templateId === 5 ? (
                                  <>
                                    <RatingScale
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      handleRadio={handleRadio}
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* NPS Scale 1-10*/}
                                {question.templateId === 6 ? (
                                  <>
                                    <NPS
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      ansNPSInput={ansNPSInput}
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      isMobile={isMobile}
                                      questionsList={questionsList}
                                      CurrQuesIndex={CurrQuesIndex}
                                      nextQues={this.nextQues}
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                      getTheme={getTheme}
                                    />
                                  </>
                                ) : null}



                                {/* NPS Scale 0-10*/}
                                {question.templateId === 16 ? (
                                  <>
                                    <NPSV2
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      ansNPSInput={ansNPSInput}
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      surveyLanguageRTL={surveyLanguageRTL}
                                    />
                                  </>
                                ) : null}






                                {/* Email */}
                                {question.templateId === 7 ? (
                                  <>
                                    <Email
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      ansTextBoxChange1={
                                        this.ansTextBoxChange1
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* Number */}
                                {question.templateId === 8 ? (
                                  <>
                                    <Number
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      ansTextBoxChange1={
                                        this.ansTextBoxChange1
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* Dropdown */}
                                {question.templateId === 9 ? (
                                  <>
                                    <Dropdown
                                      question={question}
                                      clicked={clicked}
                                      answersList={answersList}
                                      handleRadio={handleRadio}
                                      handleDropdownSelect={
                                        this.handleDropdownSelect
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* Yes/No */}
                                {question.templateId === 11 ? (
                                  <>
                                    <YesNo
                                      question={question}
                                      clicked={clicked}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      handleRadio={handleRadio}
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                    />
                                  </>
                                ) : null}

                                {/* Date */}
                                {question.templateId === 12 ? (
                                  <>
                                    <Date
                                      question={question}
                                      answersList={answersList}
                                      surveyLanguageCode={
                                        surveyLanguageCode
                                      }
                                      ansTextBoxChange1={
                                        this.ansTextBoxChange1
                                      }
                                      surveyScreenData={
                                        surveyScreenData
                                      }
                                      clickOK={this.clickOK}
                                      SurveyAttributes={
                                        SurveyAttributes
                                      }
                                    />
                                  </>
                                ) : null}




                              </div>

                              <div
                                className={
                                  question.templateId === 13
                                    ? "px-4 -pt-4 justify-center items-center"
                                    : "px-4 pt-4 justify-center items-center"
                                }
                              >
                                {unattemptList &&
                                  showRedFlag ? (
                                  unattemptList &&
                                    unattemptList.length >
                                    0 ? (
                                    <p className="px-4 font-light text-gray-100 md:px-6 md:text-md">
                                      <span
                                        style={{
                                          cursor: "default",
                                          color:
                                            surveyScreenData &&
                                              surveyScreenData.textcolor
                                              ? surveyScreenData.textcolor
                                              : "black",
                                        }}
                                        className="font-semibold"
                                      >
                                        {
                                          "Please attempt mandatory question no. "
                                        }
                                      </span>
                                      {unattemptList.map(
                                        (elem, index) => (
                                          <span
                                            key={index}
                                            onClick={() =>
                                              onMandatoryAttempt(
                                                elem
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                              color:
                                                surveyScreenData &&
                                                  surveyScreenData.textcolor
                                                  ? surveyScreenData.textcolor
                                                  : "black",
                                            }}
                                          >
                                            {index + 1 ===
                                              unattemptList
                                                .length ? (
                                              <span
                                                style={{
                                                  textDecoration:
                                                    "underline",
                                                }}
                                              >
                                                {" " + elem}
                                              </span>
                                            ) : (
                                              <span
                                                style={{
                                                  textDecoration:
                                                    "underline",
                                                }}
                                              >
                                                {elem + " , "}
                                              </span>
                                            )}
                                          </span>
                                        )
                                      )}
                                    </p>
                                  ) : null
                                ) : null}
                              </div>

                              {ShowSubmitButton ? (
                                <>
                                  <div className="px-4 text-center text-red-500">
                                    {submitMandatory}
                                  </div>

                                  <div className="flex justify-center mt-6">
                                    <button
                                      onClick={() =>
                                        saveAnswers()
                                      }
                                      className="md:w-80 w-60  uppercase md:text-xl text-base font-medium rounded-md relative inline-flex group items-center justify-center px-4 py-4 cursor-pointer  bg-gradient-to-tr bg-[#2196f3] text-white overflow-hidden "
                                    >
                                      {SurveyAttributes(
                                        "Submit"
                                      )
                                        ? SurveyAttributes(
                                          "Submit"
                                        )
                                        : "Submit"}
                                    </button>
                                  </div>
                                </>
                              ) : null}
                            </>

                          ) : null
                        )
                        : null}

                      <div dir="rtl" className="fixed bottom-0 left-0 w-full">
                        <div className="w-full px-4 py-4 mx-auto xl:w-11/12 xl:px-0 md:py-6 md:bg-transparent bg-white/10">
                          <div className="flex justify-end w-full">
                            <div className="flex flex-col items-center w-full space-y-4 md:justify-center 2xl:space-y-10 xl:space-y-10 ">
                              <div className="flex justify-center w-full md:justify-end">
                                <p
                                  className="text-sm text-white/80 "
                                  style={{
                                    color: getTheme("text", "#FFFFFF"),
                                  }}
                                >
                                  © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}
                                  <b
                                    className="ml-1 font-medium text-white/100"
                                    style={{
                                      color: getTheme("text", "#FFFFFF"),
                                    }}
                                  >
                                    {SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}
                                  </b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              ) : null}


              {/* Thank you section */}
              {showThankyouScreen ? (
                <>
                  <div dir="rtl" className="h-[calc(100vh-8rem)] flex items-center justify-center">
                    <section className="flex items-start w-full px-6 py-10 mx-auto 2xl:w-8/12 xl:w-10/12 xl:px-0 md:space-x-10 ">
                      <div className="w-full mx-auto space-y-10 text-center lg:w-[40rem] md:p-10 p-6 bg-white rounded-2xl shadow-lg shadow-black/5">
                        <div className="space-y-2 text-base font-normal text-white/80 ">
                          <div className="flex flex-col items-center justify-center space-y-2">
                            {/* Circular Progress */}
                            {showViewReportThankYouButton ? (
                              <>
                                <div className="relative size-48">
                                  <svg className="size-full" width={180} height={180} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                                    {/* Background Circle */}
                                    <circle cx={18} cy={18} r={16} fill="none" className="stroke-current  text-[#E3F2FD]" strokeWidth={3} />
                                    {/* Progress Circle inside a group with rotation */}
                                    <g className="origin-center -rotate-90 transform">
                                      <circle cx={18} cy={18} r={16} fill="none" className="stroke-current text-[#2196f3]" strokeWidth={3}
                                        strokeDasharray={100}
                                        strokeDashoffset={downloadStatusNo} />
                                    </g>
                                  </svg>
                                  {/* Percentage Text */}
                                  <div className="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M66.6673 26.667L46.6673 6.66699H20.0007C18.2325 6.66699 16.5368 7.36937 15.2866 8.61961C14.0364 9.86986 13.334 11.5655 13.334 13.3337V66.667C13.334 68.4351 14.0364 70.1308 15.2866 71.381C16.5368 72.6313 18.2325 73.3337 20.0007 73.3337H60.0006C61.7688 73.3337 63.4645 72.6313 64.7147 71.381C65.9649 70.1308 66.6673 68.4351 66.6673 66.667V26.667ZM30.0007 63.3337H23.334V33.3337H30.0007V63.3337ZM43.334 63.3337H36.6673V43.3337H43.334V63.3337ZM56.6673 63.3337H50.0007V53.3337H56.6673V63.3337ZM46.6673 30.0003H43.334V13.3337L60.0006 30.0003H46.6673Z" fill="#2196F3" />
                                    </svg>
                                  </div>
                                </div>

                                <h1 className="text-2xl font-bold text-white md:text-4xl pt-4" style={{ color: getTheme("text", "#FFFFFF") }}>
                                  {SurveyAttributes("Generating_Report") ? SurveyAttributes("Generating_Report") + "!" : "Generating Report!"}</h1>
                                <p className="pb-2 md:text-xl text-lg font-normal text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                  {SurveyAttributes("Please_wait_a_moment_while_report_is_generating") ? SurveyAttributes("Please_wait_a_moment_while_report_is_generating") + "!" : "Please wait a moment while report is generating!"}</p>

                              </>
                            ) : (
                              <>
                                <div className="md:w-[11rem] w-[9rem] md:h-[11rem] h-[9rem] rounded-full bg-white/10 flex justify-center items-center" style={{ background: getTheme("lightblue", hexToRgbA("#FFFFFF", "0.10")), }}>
                                  <div style={{ background: getTheme("textblue", hexToRgbA("#FFFFFF", "0.10")), }} className="md:w-[9rem] w-[7rem] h-[7rem] md:h-[9rem] rounded-full bg-white/20 flex justify-center items-center">
                                    <span className="material-icons md:text-[4.5rem] text-[4rem] text-white">  thumb_up  </span>
                                  </div>
                                </div>
                                <h1 className="text-2xl font-bold text-white md:text-4xl pt-4" style={{ color: getTheme("text", "#FFFFFF") }}>
                                  {SurveyAttributes("Thank You") ? SurveyAttributes("Thank You") : "Thank You!"}</h1>
                                <p className="pb-2 md:text-xl text-lg font-normal text-white/100" style={{ color: getTheme("text", "#FFFFFF") }}>
                                  {SurveyAttributes("For taking the assessment survey") ? SurveyAttributes("For taking the assessment survey") + "." : "For taking the assessment survey.!"}
                                </p>
                              </>
                            )}


                          </div>


                        </div>

                        <div className="fixed bottom-0 left-0 w-full">
                          <div className="w-full px-4 py-4 mx-auto xl:w-11/12 xl:px-0 md:py-6 md:bg-transparent bg-white/10">
                            <div className="flex justify-end w-full">
                              <div className="flex flex-col items-center w-full space-y-4 md:justify-center 2xl:space-y-10 xl:space-y-10 ">
                                <div className="flex justify-center w-full md:justify-end">
                                  <p
                                    className="text-sm text-white/80 "
                                    style={{
                                      color: getTheme("text", "#FFFFFF"),
                                    }}
                                  >
                                    © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}
                                    <b
                                      className="ml-1 font-medium text-white/100"
                                      style={{
                                        color: getTheme("text", "#FFFFFF"),
                                      }}
                                    >
                                      {SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}
                                    </b>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/*  */}
                    </section>
                  </div>
                </>
              ) : null}
            </>
          ) : null}

          {(surveyStatus === 2 &&
            !(questionsList && questionsList.length > 0)) ||
            alreadySubmitted ? ( //already done
            <div className="">
              <section className="px-6 py-6 mx-auto xl:w-3/6 lg:w-4/6 lg:px-0 md:px-6 ">
                <div className="flex justify-center pb-16 mt-12">
                </div>
                <div className="flex items-center justify-center h-full">
                  <div className="text-center text-white">
                    <div className="flex justify-center pb-8">
                      <img
                        alt="pic"
                        src="pictures/surveydone.png"
                        className="md:w-auto w-6/6 "
                      />
                    </div>
                    <h1
                      className="text-3xl font-bold leading-10 tracking-widest text-gray-800 md:text-4xl leading_lose"
                      style={{}}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          color:
                            surveyScreenData && surveyScreenData.textcolor
                              ? surveyScreenData.textcolor
                              : "black",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            SurveyAttributes("AlreadyText")
                              ? "<h1>" +
                              SurveyAttributes("AlreadyText") +
                              "</h1>"
                              : "<h1>Survey Is Already Submitted !</h1>",
                        }}
                      />
                    </h1>
                    <p className="py-2 text-xl font-light opacity-80"></p>
                  </div>
                </div>
              </section>

              <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed left-0 flex justify-center w-full bg-white bg-opacity-100 bottom-6"
              >
                <p
                  className="py-4 text-sm"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"}
                  <b className="font-semibold">{SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}</b>
                </p>
              </div>
            </div>
          ) : null}

          {/* survey expired page ----------------------------------------------------------------------------------------------- */}

          {surveyStatus === 3 &&
            !(questionsList && questionsList.length > 0) ? ( //expired
            <div>
              <section className="flex items-center justify-center px-2 py-32 mx-auto overflow-y-hidden lg:w-4/6 lg:px-0 md:px-6">
                {/* logo */}
                <div>
                  <div className="flex justify-center">
                    <img src="img/expiry.png" className="w-32" />
                  </div>
                  <div className="flex items-center justify-center h-full">
                    <div
                      className="mt-6 text-2xl font-bold text-center"
                      style={{
                        textAlign: "center",
                        color:
                          surveyScreenData && surveyScreenData.textcolor
                            ? surveyScreenData.textcolor
                            : "black",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:

                          SurveyAttributes("ExpiryText")
                            ? "<h1>" +
                            SurveyAttributes("ExpiryText") +
                            "</h1>"
                            : "<h1>This Survey is <br>Expired!</h1>",
                      }}
                    />
                  </div>
                </div>
              </section>

              <div
                style={{
                  height: "10%",
                  backgroundColor:
                    bgType === 1 || afterSubmitData.bgType === 1
                      ? bgColor
                        ? bgColor
                        : afterSubmitData.bgColor
                          ? afterSubmitData.bgColor
                          : "#757575"
                      : "#f1f1f1",
                  backgroundImage:
                    bgType === 2 || afterSubmitData.bgType === 2
                      ? bgImage
                        ? bgImage
                        : afterSubmitData.bgImage
                          ? afterSubmitData.bgImage
                          : null
                      : null,
                }}
                className="fixed left-0 flex justify-center w-full bg-white bg-opacity-100 bottom-6"
              >
                <p
                  className="py-4 text-sm"
                  style={{ color: getTheme("text", "#FFFFFF") }}
                >
                  {" "}
                  © {SurveyAttributes("Powered by") ? SurveyAttributes("Powered by") : "Powered by"} <b className="font-semibold">{SurveyAttributes("HappyPlus") ? SurveyAttributes("HappyPlus") : "HappyPlus"}</b>
                </p>
              </div>
            </div>
          ) : null}
        </div>

      </>
    );
  }
}
SurveyRTL.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users } = state;
  return {
    loggingIn,
    questions,
    users,
  };
}

export default connect(mapStateToProps)(SurveyRTL);
